import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const VERSES = [
  { t: "As iron sharpens iron, so one man sharpens another.", r: "Proverbs 27:17" },
  { t: "Be strong and courageous. Do not be afraid; do not be discouraged.", r: "Joshua 1:9" },
  { t: "I can do all things through Christ who strengthens me.", r: "Philippians 4:13" },
  { t: "Watch, stand fast in the faith, be brave, be strong.", r: "1 Corinthians 16:13" },
  { t: "The Lord is my strength and my shield; my heart trusts in him.", r: "Psalm 28:7" },
  { t: "Let all that you do be done in love.", r: "1 Corinthians 16:14" },
  { t: "Commit your work to the Lord, and your plans will be established.", r: "Proverbs 16:3" },
];

export function SplashScreen({ onDone }) {
  const [visible, setVisible] = useState(true);
  const [verse] = useState(() => VERSES[Math.floor(Math.random() * VERSES.length)]);

  return (
    <AnimatePresence onExitComplete={onDone}>
      {visible && (
        <motion.div
          data-testid="splash-screen"
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-navy overflow-hidden"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
        >
          <div className="aurora-layer absolute inset-0 pointer-events-none opacity-40" aria-hidden="true">
            <div className="aurora aurora-1" />
            <div className="aurora aurora-2" />
          </div>

          <motion.img
            src="/logo-light.png"
            alt="In His Image Movement Ministries"
            data-testid="splash-logo"
            className="h-28 sm:h-36 w-auto object-contain relative z-10"
            initial={{ opacity: 0, scale: 0.92, filter: "blur(6px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.1, ease: EASE }}
          />

          <div className="mt-8 overflow-hidden relative z-10 py-[0.12em] px-[0.1em]">
            <motion.p
              data-testid="splash-welcome"
              className="font-serif italic text-bone text-5xl sm:text-7xl tracking-tight leading-[1.15]"
              initial={{ y: "115%", opacity: 0 }}
              animate={{ y: "0%", opacity: 1 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.7 }}
            >
              Welcome
            </motion.p>
          </div>

          <motion.div
            data-testid="splash-verse"
            className="mt-5 text-center relative z-10 px-8 max-w-lg"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: EASE, delay: 1.35 }}
          >
            <p className="font-serif italic text-bone/75 text-base sm:text-lg leading-snug">“{verse.t}”</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mt-3">{verse.r}</p>
          </motion.div>

          <motion.button
            data-testid="splash-enter"
            onClick={() => setVisible(false)}
            className="group mt-12 inline-flex items-center gap-3 border border-gold/50 text-bone px-10 py-3.5 font-mono text-xs uppercase tracking-[0.3em] hover:bg-gold hover:text-navy hover:border-gold transition-colors relative z-10"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 1.9 }}
          >
            Enter <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
